import styled from 'styled-components';

export const Wrapper = styled.div`
  .job-images {
    border-radius: 10px;
  }

  ion-accordion {
    /* --background: var(--ion-color-lightest);

    ion-item {
      --border-radius: 10px;
    } */

    box-shadow: none;
    div[slot='content'] {
      background-color: var(--ion-color-lightest);
    }
  }
`;
